var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c("section-title", {
          attrs: { "has-line": "", title: "Información de Contrato" }
        }),
        _c("div", { staticClass: "row ml-2 mb-5" }, [
          _c("div", { staticClass: "col" }, [
            _c(
              "span",
              { staticClass: "color-secondary-6 font-14 font-weight-normal" },
              [_vm._v(" Contract ID: ")]
            ),
            _c(
              "div",
              { staticClass: "color-black font-16 font-weight-normal" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("empty")(_vm.contractDetails.contractId)) +
                    " "
                )
              ]
            )
          ]),
          _c("div", { staticClass: "col" }, [
            _c(
              "span",
              { staticClass: "color-secondary-6 font-14 font-weight-normal" },
              [_vm._v(" Contract Line: ")]
            ),
            _c(
              "div",
              { staticClass: "color-black font-16 font-weight-normal" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm._f("empty")(_vm.contractDetails.contractLine)) +
                    " "
                )
              ]
            )
          ]),
          _c("div", { staticClass: "col" }, [
            _c(
              "span",
              { staticClass: "color-secondary-6 font-14 font-weight-normal" },
              [_vm._v(" Distribution Line: ")]
            ),
            _c(
              "div",
              { staticClass: "color-black font-16 font-weight-normal" },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm._f("empty")(_vm.contractDetails.distributionLine)
                    ) +
                    " "
                )
              ]
            )
          ])
        ]),
        _c(
          "div",
          [
            _c("icon-view", {
              staticClass: "mb-3",
              attrs: {
                gradient: "",
                icon: "fas fa-list",
                "icon-background": "#FF7058",
                "icon-color": "#fff",
                title: "Información de PO"
              }
            }),
            _vm._l(_vm.value.purchaseOrders, function(po, index) {
              return _c(
                "custom-callout",
                {
                  key: `po-item-${index}`,
                  staticClass: "mb-2",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "edition",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "p-2 mt-1" },
                              [
                                _vm._l(po.details, function(row, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: `address-item-${i}`,
                                      staticClass:
                                        "bg-white rounded p-3 row mb-2 mx-0"
                                    },
                                    [
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" Line Number: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(row.lineNumber) + " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" Item ID: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("empty")(row.itemId)
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" PO Distribution Line: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(row.poDistributionLine) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" Fund Code: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(row.fundCode) + " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" Project ID: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("empty")(row.projectId)
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" Line Status: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("empty")(
                                                    row.lineStatus
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" Merchandise Amount: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("price")(
                                                    row.merchandiseAmount
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" Merchandise VC: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("price")(
                                                    row.merchandiseAmountVC
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]),
                                      _c("div", { staticClass: "col" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "color-secondary-6 font-14 font-weight-normal"
                                          },
                                          [_vm._v(" DOE Balance Amount: ")]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "color-black font-16 font-weight-normal"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("price")(
                                                    row.doeBalanceAmount
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                }),
                                po.details.length == 0
                                  ? _c("custom-result-not-found")
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("div", { staticClass: "row py-2" }, [
                    _c(
                      "div",
                      { staticClass: "col d-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-secondary-6 font-14 font-weight-normal mr-2"
                          },
                          [_vm._v(" PO ID: ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "color-black font-16 font-weight-bold"
                          },
                          [_vm._v(" " + _vm._s(po.purchaseOrderId) + " ")]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col d-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-secondary-6 font-14 font-weight-normal mr-2"
                          },
                          [_vm._v(" Estatus: ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "color-black font-16 font-weight-bold"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getStatusDescription(po.status)) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col d-flex justify-content-end align-items-center"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-secondary-6 font-14 font-weight-normal mr-2"
                          },
                          [_vm._v(" Merchandise Balance: ")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass:
                              "color-black font-16 font-weight-bold color-green"
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("price")(po.merchandiseBalance)) +
                                " "
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-2 d-flex justify-content-center" },
                      [
                        _c(
                          "span",
                          { staticClass: "color-gray-8 font-14 pr-3 mt-1" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm._f("date")(po.lastUpdatedDate)) +
                                " "
                            )
                          ]
                        ),
                        po.status === "D"
                          ? _c("action-button", {
                              staticClass:
                                "py-1 px-0 pl-2 d-flex justify-content-center align-items-center",
                              attrs: {
                                i: "fas fa-redo-alt pr-2 pt-1",
                                variant: "outline-success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.$emit(
                                    "on-update-po",
                                    po.purchaseOrderId
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              )
            }),
            _vm.value.purchaseOrders.length == 0
              ? _c("custom-result-not-found")
              : _vm._e()
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }